
import { defineComponent } from 'vue';
import CloseBtn from "../pageElements/CloseBtn.vue";

export default defineComponent({
    name: "MailForm",

    components:{
        CloseBtn
    },

    props: [
        "popupVisible",
        "popupMsg"
    ],

    data(){
        return{

        } 
    },

    methods:{

        

    }

});
